import { InsertRowLeftOutlined, UndoOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest } from "../../../axios";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import PlusSquareOutlined from "../../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import "../../../styles/Main.scss";
import { ErrorNotificationMsg } from "../../../utils/Notifications";
// import AddStateModel from "./AddStateModel";

// import { authUserData } from "../../../utils/Helper";
// import BulkStateUpload from "../../stateMaster/BulkStateUpload";
import AddPackageMaster from "./AddPackageMaster";

const PackageMasterList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [packageType, setpackageType] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [stateId, setStateId] = useState(null);
  // const [newZoneAdded, setNewZoneAdded] = useState(false);
  const [modalKey, setModalKey] = useState(false);
  // const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getPackageTypeList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("package-type/", state);
        if (apiResponse.data.results.success) {
          setpackageType(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_zone_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getPackageTypeList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    setSelectedRow(selectedRow);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });
    form.setFieldsValue({ search: "" });
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "package_type" && sortOrder === "ascend") {
      sortingEnumKey = "package_type";
    }
    if (sortField === "package_type" && sortOrder === "descend") {
      sortingEnumKey = "-package_type";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const [checkedList, setCheckedList] = useState(["package_type", "operation"]);
  const [columns, setColumns] = useState([
    {
      title: "Name",
      dataIndex: "package_type",
      key: "package_type",
      sorter: true,
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="left"
            title={<span style={{ color: "#fff" }}>Edit</span>}
          > */}
          {/* {authUserData()?.permission.includes(
              "common|change_states"
            ) && ( */}
          <Editicon
            onClick={() => handleEdit(record.id)}
            style={{ cursor: "pointer" }}
          />
          {/* )} */}
          {/* </Tooltip> */}
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Archive</span>}
          >
            {authUserData()?.permission.includes(
              "common|delete_states"
            ) && (
                <Popconfirm
                  className="action"
                  title={t("pop_title")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  onConfirm={() => handleArchive(record.id)}
                >
                  <Archive style={{ cursor: "pointer" }} />
                </Popconfirm>
              )} */}
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="package_type">Name</Checkbox>
            </Col>

            <Col span={12}>
              <Checkbox value="operation" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handleEdit = (id) => {
    setModalKey((prevKey) => !prevKey);
    setStateId(id);
    showModal();
  };
  const handleAdd = () => {
    setStateId(null);
    showModal();
  };

  // const handleArchive = async (id = []) => {
  //   let ids = [...selectedRow];

  //   if (ids.length === 0 && id) {
  //     ids.push(id);
  //   }
  //   try {
  //     let apiResponse = await postRequest("state/archive-state/", {
  //       deleted: ids,
  //     });
  //     if (apiResponse.data.success) {
  //       let totalArchive = totalCount - ids?.length;

  //       if (totalArchive < 11) {
  //         setState((prevState) => ({
  //           ...prevState,
  //           page: 1,
  //           search: "",
  //         }));
  //         setReload(!reload);
  //       } else {
  //         setReload(!reload);
  //       }
  //       SuccessNotificationMsg(t("state_archive_successfuly"));

  //       setSelectedRow([]);
  //     } else {
  //       setState((prevState) => ({
  //         ...prevState,
  //         page: 1,
  //         search: "",
  //       }));
  //       ErrorNotificationMsg(t("error_in_archive_state"));
  //     }
  //   } catch (error) {
  //     setState((prevState) => ({
  //       ...prevState,
  //       page: 1,
  //       search: "",
  //     }));
  //   }
  // };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  // const handleOkBulk = () => {
  //   setIsModalOpenBulk(false);
  // };
  // const handleCancelBulk = () => {
  //   setIsModalOpenBulk(false);
  // };
  const colors = ["#737373"];
  return (
    <>
    <div className="mainwrapper">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("Package Type")}</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Package Type")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}

            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Create New Package Type For Organizing
                </span>
              }
            > */}
            {/* {authUserData()?.permission.includes(
                "common|add_states"
              ) && ( */}
            <Button
              className="BlueShadowBtn"
              type="primary"
              onClick={handleAdd}
              icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
            >
              {t("Add Package Type")}
            </Button>
            {/* )} */}
            {/* </Tooltip>
             */}
            <Modal
              className="ModelPopupSec"
              title={stateId ? t("Edit Package Type") : t("Add Package Type")}
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              closable={false}
              wrapClassName="modal-wrapper"
              keyboard={false}
            >
              <AddPackageMaster
                handleCancel={handleCancel}
                setReload={setReload}
                stateId={stateId}
                modalKey={modalKey}
                setStateM={setState}
              />
            </Modal>

            {/* <Modal
              className="ModelPopupSec"
              title="Upload File"
              open={isModalOpenBulk}
              onOk={handleOkBulk}
              onCancel={handleCancelBulk}
              closable={false}
              wrapClassName="modal-wrapper"
            >
              <BulkStateUpload
                setNewZoneAdded={setNewZoneAdded}
                newZoneAdded={newZoneAdded}
                stateId={stateId}
                handleCancelBulk={handleCancelBulk}
              />
            </Modal> */}

            {/* {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label="Archive"
                />
              </Popconfirm>
            )} */}

            {/* <Tooltip placement="topLeft" title="View Archived Records">
              <Link className="Archiveicon" to="/state/archive">
                <Archiveicon />
              </Link>
            </Tooltip> */}
            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>
      <section className="grid-sec">
        <div className="Package-body">
          <div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={packageType}
            loading={loading}
            pagination={{
              current: state.page,
              pageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{ x: 500 }}
          />
          </div>
        </div>
      </section>
      </div>
    </>
  );
};
export default PackageMasterList;
